// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/user_summary.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/user_summary.proto.
 */
export const file_studyo_today_planners_v1_resources_user_summary = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3VzZXJfc3VtbWFyeS5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJdCgtVc2VyU3VtbWFyeRIRCglmdWxsX25hbWUYASABKAkSFQoNZW1haWxfYWRkcmVzcxgCIAEoCRITCgtwaWN0dXJlX3VybBgDIAEoCRIPCgd1c2VyX2lkGAQgASgJQiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.planners.v1.resources.UserSummary.
 * Use `create(UserSummarySchema)` to create a new message.
 */
export const UserSummarySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_user_summary, 0);

